import React, { useEffect, useState } from "react";
import { getImageFromDB, storeImageInDB } from '../../../utils/indexdb.utils';
import "./styles.css";

const LOADING_GIF_KEY = "loading-gif";
const GIF_URL = "https://lotteryblob.blob.core.windows.net/lottery-files/loading.gif";

const LoadingSpinner: React.FC = () => {
  const [loadingSrc, setLoadingSrc] = useState<string | null>(null);

  useEffect(() => {
    const fetchAndCacheGif = async () => {
      try {
        const cachedGif = await getImageFromDB(LOADING_GIF_KEY);

        if (cachedGif) {
          setLoadingSrc(URL.createObjectURL(cachedGif));
        } else {
          const response = await fetch(GIF_URL);
          const blob = await response.blob();

          await storeImageInDB(LOADING_GIF_KEY, blob);
          setLoadingSrc(URL.createObjectURL(blob));
        }
      } catch (error) {
        console.error("Error al cargar el GIF:", error);
        setLoadingSrc(GIF_URL); 
      }
    };

    fetchAndCacheGif();
  }, []);

  return (
    <div className="gif-container">
      {loadingSrc ? (
        <img src={loadingSrc} alt="Cargando..." className="responsive-gif" />
      ) : (
        <p>Cargando...</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
